module.exports = __webpack_public_path__ + "img/activities-5.d8da2d57.jpg";